// CardPackBattle v1 ABI — 0xd72f3e28A2C16C98c6fc979FD3037f15DEbE1897

export const CARD_PACK_BATTLE_ADDRESS =
  (import.meta.env.VITE_CARD_BATTLE_ADDRESS ??
   "0xd72f3e28A2C16C98c6fc979FD3037f15DEbE1897") as `0x${string}`;

export const CARD_PACK_BATTLE_ABI = [
  // ── Create ────────────────────────────────────────────────────────────────
  {
    inputs: [
      { internalType: "uint8",  name: "tier",      type: "uint8"  },
      { internalType: "uint8",  name: "payToken",  type: "uint8"  },
      { internalType: "uint8",  name: "mode",      type: "uint8"  },
      { internalType: "uint8",  name: "maxSlots",  type: "uint8"  },
      { internalType: "bool",   name: "isPrivate", type: "bool"   },
    ],
    name: "createBattle",
    outputs: [{ internalType: "uint256", name: "battleId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  // ── Join ──────────────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "uint256", name: "battleId", type: "uint256" }],
    name: "joinBattle",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  // ── Cancel ────────────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "uint256", name: "battleId", type: "uint256" }],
    name: "cancelBattle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  // ── Timeout claim ─────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "uint256", name: "battleId", type: "uint256" }],
    name: "claimTimeout",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  // ── Views ─────────────────────────────────────────────────────────────────
  {
    inputs: [{ internalType: "uint256", name: "battleId", type: "uint256" }],
    name: "getBattle",
    outputs: [
      {
        components: [
          { internalType: "uint8",     name: "tier",        type: "uint8"     },
          { internalType: "uint8",     name: "payToken",    type: "uint8"     },
          { internalType: "uint8",     name: "mode",        type: "uint8"     },
          { internalType: "uint8",     name: "maxSlots",    type: "uint8"     },
          { internalType: "uint8",     name: "filledSlots", type: "uint8"     },
          { internalType: "uint8",     name: "status",      type: "uint8"     },
          { internalType: "bool",      name: "isPrivate",   type: "bool"      },
          { internalType: "address",   name: "creator",     type: "address"   },
          { internalType: "address",   name: "winner",      type: "address"   },
          { internalType: "uint256",   name: "entryAmount", type: "uint256"   },
          { internalType: "uint256",   name: "createdAt",   type: "uint256"   },
          { internalType: "uint256",   name: "startedAt",   type: "uint256"   },
          { internalType: "address[]", name: "players",     type: "address[]" },
          { internalType: "uint256[]", name: "seeds",       type: "uint256[]" },
        ],
        internalType: "struct CardPackBattle.Battle",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOpenBattles",
    outputs: [{ internalType: "uint256[]", name: "ids", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getActiveBattles",
    outputs: [{ internalType: "uint256[]", name: "ids", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "battleCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint8", name: "tier",     type: "uint8" },
      { internalType: "uint8", name: "payToken", type: "uint8" },
    ],
    name: "entryFee",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rakeBps",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  // ── Events ────────────────────────────────────────────────────────────────
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "uint256", name: "battleId",    type: "uint256" },
      { indexed: true,  internalType: "address", name: "creator",     type: "address" },
      { indexed: false, internalType: "uint8",   name: "tier",        type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "payToken",    type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "mode",        type: "uint8"   },
      { indexed: false, internalType: "uint8",   name: "maxSlots",    type: "uint8"   },
      { indexed: false, internalType: "uint256", name: "entryAmount", type: "uint256" },
      { indexed: false, internalType: "bool",    name: "isPrivate",   type: "bool"    },
    ],
    name: "BattleCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "uint256", name: "battleId",  type: "uint256" },
      { indexed: false, internalType: "uint8",   name: "slotIndex", type: "uint8"   },
      { indexed: true,  internalType: "address", name: "player",    type: "address" },
      { indexed: false, internalType: "uint256", name: "seed",      type: "uint256" },
    ],
    name: "BattleSlotFilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "battleId", type: "uint256" },
    ],
    name: "BattleActive",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "uint256",   name: "battleId",    type: "uint256"   },
      { indexed: true,  internalType: "address",   name: "winner",      type: "address"   },
      { indexed: false, internalType: "uint256[]", name: "cardValues",  type: "uint256[]" },
      { indexed: false, internalType: "uint256[]", name: "seeds",       type: "uint256[]" },
      { indexed: false, internalType: "uint256",   name: "prizeAmount", type: "uint256"   },
    ],
    name: "BattleResolved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true,  internalType: "uint256", name: "battleId", type: "uint256" },
      { indexed: false, internalType: "string",  name: "reason",   type: "string"  },
    ],
    name: "BattleCancelled",
    type: "event",
  },
] as const;
